// -----------------------------------------------------------------------------
// Exports Breakpoints.
// -----------------------------------------------------------------------------

export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 1025,
  max: 1366,
};

// -----------------------------------------------------------------------------
// Exports Various Slider Configs.
// -----------------------------------------------------------------------------

export const sliderConfigs = {
  // --------------------------------------------------------
  // Default slider.
  // --------------------------------------------------------

  defaults: {
    infinite: false,
    arrowsPlacement: `afterSlides`,
  },

  // -------------------------------------------------------
  // Testimonials Slider
  // -------------------------------------------------------

  testimonials: {
    advanceOnDotsHover: true, // custom option
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          adaptiveHeight: false,
        },
      },
    ],
  },

  // -------------------------------------------------------
  // Related Scientists Slider
  // -------------------------------------------------------

  related_scientists: {
    arrowsPlacement: `split`,
    prevArrow: `<button class="slick-prev slick-arrow" type="button"><span class="icon material-icons-outlined" aria-hidden="true">navigate_before</span><span class="visually-hidden">Previous</span></button>`,
    nextArrow: `<button class="slick-next slick-arrow" type="button"><span class="icon material-icons-outlined" aria-hidden="true">navigate_next</span><span class="visually-hidden">Next</span></button>`,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: breakpoints.max,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: breakpoints.lg,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: breakpoints.md,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  },

  related_scientists_four: {
    arrowsPlacement: `split`,
    prevArrow: `<button class="slick-prev slick-arrow" type="button"><span class="icon material-icons-outlined" aria-hidden="true">navigate_before</span><span class="visually-hidden">Previous</span></button>`,
    nextArrow: `<button class="slick-next slick-arrow" type="button"><span class="icon material-icons-outlined" aria-hidden="true">navigate_next</span><span class="visually-hidden">Next</span></button>`,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: breakpoints.lg,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: breakpoints.md,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  },

  related_scientists_three: {
    arrowsPlacement: `split`,
    prevArrow: `<button class="slick-prev slick-arrow" type="button"><span class="icon material-icons-outlined" aria-hidden="true">navigate_before</span><span class="visually-hidden">Previous</span></button>`,
    nextArrow: `<button class="slick-next slick-arrow" type="button"><span class="icon material-icons-outlined" aria-hidden="true">navigate_next</span><span class="visually-hidden">Next</span></button>`,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: breakpoints.md,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  },

  related_scientists_two: {
    arrowsPlacement: `split`,
    prevArrow: `<button class="slick-prev slick-arrow" type="button"><span class="icon material-icons-outlined" aria-hidden="true">navigate_before</span><span class="visually-hidden">Previous</span></button>`,
    nextArrow: `<button class="slick-next slick-arrow" type="button"><span class="icon material-icons-outlined" aria-hidden="true">navigate_next</span><span class="visually-hidden">Next</span></button>`,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
  },

  // --------------------------------------------------------
  // Media Player :: Main
  // --------------------------------------------------------

  mediaPlayer: {
    asNavFor: '.media-gallery__thumbs',
    regionLabel: 'main media carousel',
    infinite: false,
    fade: true,
    swipe: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  },

  // --------------------------------------------------------
  // Media Player :: Thumbnails.
  // --------------------------------------------------------

  mediaPlayerThumbs: {
    infinite: false,
    asNavFor: '.media-gallery__items',
    regionLabel: 'thumbnail carousel',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrowsPlacement: `split`,
    prevArrow: `<button class="slick-prev slick-arrow" type="button"><span class="icon material-icons-outlined" aria-hidden="true">navigate_before</span><span class="visually-hidden">Previous</span></button>`,
    nextArrow: `<button class="slick-next slick-arrow" type="button"><span class="icon material-icons-outlined" aria-hidden="true">navigate_next</span><span class="visually-hidden">Next</span></button>`,
    instructionsText:
      'Changing the current slide of this carousel will change the slide in the main video and image carousel',
    mobileFirst: true,
    dots: false,
    responsive: [
      {
        breakpoint: breakpoints.sm,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: breakpoints.md,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: breakpoints.max,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  },
};

export const mediaPlayerThumbs = (items) => {
  var responsive = [
    {
      breakpoint: breakpoints.sm,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: breakpoints.md,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: breakpoints.max,
      settings: {
        slidesToShow: 4,
      },
    },
  ];

  if (items == 4) {
    responsive = [
      {
        breakpoint: breakpoints.sm,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: breakpoints.md,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: breakpoints.lg,
        settings: {
          slidesToShow: 3,
        },
      },
    ];
  }

  if (items == 3) {
    responsive = [
      {
        breakpoint: breakpoints.sm,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: breakpoints.md,
        settings: {
          slidesToShow: 3,
        },
      },
    ];
  }

  if (items == 2) {
    responsive = [
      {
        breakpoint: breakpoints.sm,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: breakpoints.md,
        settings: {
          slidesToShow: 2,
        },
      },
    ];
  }

  var mediaPlayerThumbs = {
    infinite: false,
    asNavFor: '.media-gallery__items',
    regionLabel: 'thumbnail carousel',
    slidesToShow: 2,
    slidesToScroll: 1,
    arrowsPlacement: `split`,
    prevArrow: `<button class="slick-prev slick-arrow" type="button"><span class="icon material-icons-outlined" aria-hidden="true">navigate_before</span><span class="visually-hidden">Previous</span></button>`,
    nextArrow: `<button class="slick-next slick-arrow" type="button"><span class="icon material-icons-outlined" aria-hidden="true">navigate_next</span><span class="visually-hidden">Next</span></button>`,
    instructionsText:
      'Changing the current slide of this carousel will change the slide in the main video and image carousel',
    mobileFirst: true,
    dots: false,
    responsive: responsive,
  };

  return mediaPlayerThumbs;
};

export const jumpmenu = (items) => {
  var infinite = true;
  var centerMode = true;
  var slidesToshow = items - 1;

  if (items === 1) {
    slidesToshow = items;
  }

  var jumpmenu = {
    infinite: true,
    slidesToShow: slidesToshow,
    speed: 300,
    centerMode: centerMode,
    variableWidth: true,
    nextArrow: '.jump-menu__list-next',
    prevArrow: '.jump-menu__list-prev',
  };

  return jumpmenu;
};

// -----------------------------------------------------------------------------
// Default exports.
// -----------------------------------------------------------------------------

export default {
  breakpoints,
  sliderConfigs,
};
